module.exports = __webpack_public_path__ + "img/inclusion-nudges.52ae7e56.png";